exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Global: estilo do span de variável dentro do contenteditable */\n.qm-variable-tag {\n    display: inline-block;\n    background: #d0eef5;\n    color: #1c6f80;\n    border: 1px solid #9dd4e0;\n    border-radius: 10px;\n    padding: 1px 8px;\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0 2px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n            user-select: none;\n    cursor: default;\n}\n", ""]);

// exports
